import secondaryComponents from "..";
import useSheduleDeliveryTable from "./useSheduleDeliveryTable";

const SheduleDeliveryTable = ({
  errors,
  setValue,
  items,
  clearErrors,
  control,
  selected,
  allSelected,
  toggleAll,
  someSelected,
  toggleItem = () => {},
  setScheduleData,
  updateScheduleField,
  register,
  trigger,
  watch,
}) => {
  const { instance } = useSheduleDeliveryTable({
    errors,
    clearErrors,
    watch,
    register,
    setValue,
    trigger,
    items,
    control,
    selected,
    allSelected,
    toggleAll,
    someSelected,
    toggleItem,
    setScheduleData,
    updateScheduleField,
  });
  const { getTableBodyProps, getTableProps, headerGroups, rows, prepareRow } =
    instance;
  return (
    <secondaryComponents.TableHelper
      getTableBodyProps={getTableBodyProps}
      getTableProps={getTableProps}
      headerGroups={headerGroups}
      rows={rows}
      prepareRow={prepareRow}
      //handleScroll={true}
      hasAction={true}
    ></secondaryComponents.TableHelper>
  );
};

export default SheduleDeliveryTable;
